import { UNAUTHORIZED } from "@/api/httpStatus";

export default {
  methods: {
    parseResponse(resp) {
      if (resp.id !== undefined || resp.error !== undefined) {
        if (resp.id > 0) {
          this.successNotify();
        } else {
          this.errorNotify(resp.error);
        }
      }
    },
    parseResponseError(code) {
      if (code !== UNAUTHORIZED) {
        this.errorNotify();
      }
    }
  }
};
